import { graphql } from "@opensea/graphql"

export const ActivityFeedLiveTimestampFragment = graphql(`
  fragment ActivityFeedLiveTimestamp on Activity {
    eventTime
    chain {
      identifier
    }
    transactionHash
  }
`)
